// Component using for Standings tabs on TournamentCard

import ColorLegend from './ColorLegend';
import StandingsTable from './StandingsTable';
import { GameTypes } from '../utils/enums';
import { useDivisions } from '../utils/hooks';
import { fadeColorLegend } from '../utils/colorLegend';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import StandingsPDF from './StandingsPDF';
import './Standings.scss';

export default function Standings({ id, colorLegend }) {
  const pdfRef = useRef(null);
  const divisions = useDivisions(id);

  const onPrintPDF = useReactToPrint({
    contentRef: pdfRef,
    documentTitle: 'Standings',
  });

  return (
    <div className='standings'>
      <div className='legend-float-host sticky-top'>
        <button className='bw small fa-pdf icon' onClick={onPrintPDF}>
          Print/Save as PDF
        </button>
        <ColorLegend id={id} colorLegend={fadeColorLegend(colorLegend)} />
      </div>
      {divisions.map((div) => (
        <div className='division' key={div}>
          <h3>{div}</h3>
          <StandingsTable
            id={id}
            division={div}
            gameType={GameTypes.POOLGAME}
            title='Pool games'
            colorLegend={colorLegend}
          />
          <StandingsTable
            id={id}
            division={div}
            gameType={GameTypes.PLAYOFF}
            title='Playoff games'
            colorLegend={colorLegend}
            hideWhenEmpty
          />
        </div>
      ))}
      <div ref={pdfRef} className='standings-pdf-wrap'>
        <StandingsPDF id={id} colorLegend={colorLegend} />
      </div>
    </div>
  );
}
